import classNames from "classnames";
import React from "react";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { Box } from "../Box";
import styles from "./stylesVertical.module.css";
import {
  MultilineText as MultilineTextComponent,
  MultilineText,
} from "../MultilineText"; // Renaming for clarity since MultilineText is both a type and a component.

interface Props {
  content: Array<{
    title: string;
    content: React.ReactNode | MultilineText;
  }>;
  tabListContainerClassName?: string;
  extraTabListItemClassName?: string;
  extraTabListClassName?: string;
  extraTabPanelClassName?: string;
}

export const SimpleTabsVertical: React.FC<React.PropsWithChildren<Props>> = ({
  content,
  tabListContainerClassName,
  extraTabListItemClassName,
  extraTabListClassName,
  extraTabPanelClassName,
}) => {
  return (
    <Tabs>
      <p className={styles.infoHeader} />
      <div className={tabListContainerClassName}>
        <TabList className={classNames(styles.tabList, extraTabListClassName)}>
          {content.map((item, idx) => (
            <Tab
              key={idx}
              className={classNames(
                styles.tabListItem,
                extraTabListItemClassName,
              )}
              selectedClassName={styles.tabListItemActive}
            >
              {item.title}
            </Tab>
          ))}
        </TabList>
        {content.map((item, idx) => (
          <TabPanel
            key={idx}
            className={classNames(styles.tabPanel, extraTabPanelClassName)}
            selectedClassName={styles.tabPanelActive}
          >
            <Box
              centeredContent={true}
              alternativeSectionClassName={styles.container}
            >
              {React.isValidElement(item.content) ? (
                item.content
              ) : typeof item.content === "object" &&
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                "content" in item.content! &&
                "isMarkdown" in item.content ? (
                <MultilineText
                  content={item.content.content}
                  isMarkdown={item.content.isMarkdown}
                />
              ) : (
                <div>Unsupported content</div>
              )}
            </Box>
          </TabPanel>
        ))}
      </div>
    </Tabs>
  );
};
